// extracted by mini-css-extract-plugin
export default {"groupedTrainings":"ProfileGroupedTrainings-module__groupedTrainings","title":"ProfileGroupedTrainings-module__title","group":"ProfileGroupedTrainings-module__group"};